<div class="bg-linear" role="button">
  <div class="contact-online online">
    <img class="contact-image" userAvatar [usercode]="username" />
  </div>
  <div class="contact-content">
    <div class="contact-name">{{fullname}}</div>
  </div>
</div>
<div class="p-2 ">
  <search-input *ngIf="!flagContactOrRoom" [placeholder]="'Tìm kiếm ...'"
                (onChanged)="searchContacts($event)"></search-input>
  <search-input *ngIf="flagContactOrRoom" [placeholder]="'Tìm kiếm phòng họp ...'"
                (onChanged)="searchGroups($event)"></search-input>
</div>

<ul class="nav nav-pills mb-2 mt-1" id="pills-tab" role="tablist">
  <li class="nav-item">
    <a class="nav-link active" (click)="searchContactOrGroup(false); loadContactSelect(contacts)" id="pills-home-tab" data-toggle="pill"
       href="#pills-home" role="tab" aria-controls="pills-home" aria-selected="true">TIN NHẮN</a>
  </li>
  <li class="nav-item">
    <a class="nav-link pl-1" (click)="searchContactOrGroup(true); loadGroup(groups)" id="pills-profile-tab" data-toggle="pill"
       href="#pills-profile" role="tab" aria-controls="pills-profile" aria-selected="false">PHÒNG HỌP</a>
  </li>
  <div class="img-create-group" (click)="createGroup()"></div>
  <div class="img-create-chat-group ml-2"></div>
</ul>
<div #contactRef class="contact-list__body">
  <div class="tab-content " id="pills-tabContent" style="height: calc( 100vh - 253px); overflow: auto;" >
    <div class="tab-pane fade show active format-scroll-box " id="pills-home" role="tabpanel"
         aria-labelledby="pills-home-tab">
      <div *ngFor="let contact of contacts;let index = index">
        <div class="contact " role="button" (click)="selectContact(contact); "
             [ngClass]="{'contact-active': checkActive(index)}">
          <div class="contact-online" [ngClass]="{'online': contact.online,'offline': !contact.online }">
            <img class="contact-image" userAvatar [usercode]="contact.usercode">
          </div>
          <div class="contact-content">
            <div class="contact-name">{{contact?.fullname}}</div>
            <div class="contact-detail" [innerHTML]="contact.message | safeHtml"></div>
          </div>

          <div *ngIf="contact.unread" class="ml-2 mr-2" style="white-space: nowrap;">
            <div class="ml-1"><span class="badge badge-pill badge-primary"
                                    style="font-size: 11px;">{{contact?.unread}}</span>
            </div>
          </div>
          <div *ngIf="contact.usercode !== username && !contact.unread" (click)="callToContact(username)"
               class="ml-2 mr-2" style="white-space: nowrap;">
            <span><i class="fa fa-ellipsis-h text-muted font-20" aria-hidden="true"></i></span>
          </div>
        </div>
      </div>
    </div>
    <div class="tab-pane fade format-scroll-box" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab"
         style="overflow: auto">
      <group-call-list (roomSelected)="selectRoom($event)" [groupList]="groups"></group-call-list>
    </div>
  </div>
</div>
<message-group (roomSelected)="selectRoomAndReload($event)"></message-group>
